import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SignInPage } from '../components/auth/SignInPage';

const signInSearchSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
  email: z.string().optional(),
  redirect: z.string().optional(),
});

export type SignInSearch = z.infer<typeof signInSearchSchema>;

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search) => signInSearchSchema.parse(search),
  component: SignIn,
});

function SignIn() {
  return <SignInPage />;
}
